class Countdown extends HTMLElement {
  constructor() {
    super()
    this.startDate = this.getAttribute("start")
    this.endDate = this.getAttribute("end")
    this.days
    this.hours
    this.minutes
    this.seconds
    this.daysElement = this.querySelector(".countdown-days")
    this.hoursElement = this.querySelector(".countdown-hours")
    this.minutesElement = this.querySelector(".countdown-minutes");
    this.secondsElement = this.querySelector(".countdown-seconds");
  }

  connectedCallback() {

    this.startDate = new Date(Date.parse(this.startDate));
    this.endDate = new Date(Date.parse(this.endDate));

    if (isNaN(this.startDate) || isNaN(this.endDate)) {
      return;
    }

    setInterval(() => this.calculate(), 1000);
  }

  calculate() {
    let now = new Date();

    if (now < this.startDate) {
      return;
    }

    let timeRemaining = parseInt((this.endDate - now) / 1000);

    if (timeRemaining >= 0) {
      this.days = parseInt(timeRemaining / 86400);
      timeRemaining = (timeRemaining % 86400);

      this.hours = parseInt(timeRemaining / 3600);
      timeRemaining = (timeRemaining % 3600);

      this.minutes = parseInt(timeRemaining / 60);
      timeRemaining = (timeRemaining % 60);

      this.seconds = parseInt(timeRemaining);

      this.daysElement.innerText = this.days
      this.hoursElement.innerText = this.hours
      this.minutesElement.innerText = this.minutes
      this.secondsElement.innerText = this.seconds
    } else {

      return;
    }
  }
}

customElements.define("countdown-section", Countdown);